/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Marker, InfoWindow } from "react-google-maps";
import JobDetail from "./MapJobDetail";

class JobMarker extends Component {
  state = {
    isOpen: false
  };

  onToggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { job } = this.props;
    const { Lat, Lng } = job.stop.location.GPS;

    if (isFinite(Lat) && Math.abs(Lat) <= 90) {
      return (
        <Marker
          title={job.customerName}
          position={{ lat: Lat, lng: Lng }}
          onClick={this.onToggleOpen}
        >
          {this.state.isOpen && (
            <InfoWindow onCloseClick={this.onToggleOpen}>
              <JobDetail job={job} />
            </InfoWindow>
          )}
        </Marker>
      );
    }

    return "";
  }
}
JobMarker.propTypes = {
  job: PropTypes.object.isRequired
};

export default JobMarker;



// WEBPACK FOOTER //
// ./src/components/jobs/JobMapMarker.js